/**
 * Featured homepage covers: blur-up crossfade after the image has loaded.
 */

function revealCoverImage(img) {
  if (img.classList.contains("is-cover-loaded")) {
    return;
  }

  // Still on the 1×1 lazysizes placeholder (or not decoded yet) — wait for a real load.
  if (!img.complete || img.naturalWidth <= 1) {
    return;
  }

  const apply = () => {
    if (img.classList.contains("is-cover-loaded")) {
      return;
    }
    void img.offsetWidth;
    img.classList.add("is-cover-loaded");
  };

  const afterReady = async () => {
    if (img.decode && img.currentSrc) {
      try {
        await img.decode();
      } catch (_) {
        /* ignore */
      }
    }
    requestAnimationFrame(() => requestAnimationFrame(apply));
  };

  afterReady();
}

function bindCoverFade(img) {
  if (img.dataset.coverFadeBound === "true") {
    return;
  }
  img.dataset.coverFadeBound = "true";

  const tryReveal = () => revealCoverImage(img);

  img.addEventListener("lazyloaded", tryReveal);
  img.addEventListener("load", tryReveal);
  img.addEventListener(
    "error",
    () => {
      img.classList.add("is-cover-loaded");
    },
    { once: true }
  );

  // Picture/<source> unveils can finish after the first load of the 1×1 gif —
  // poll briefly until a real bitmap is ready, then stop.
  if (img.classList.contains("lazyloaded") || img.complete) {
    tryReveal();
  }

  if (!img.classList.contains("is-cover-loaded")) {
    let attempts = 0;
    const maxAttempts = 40;
    const poll = window.setInterval(() => {
      attempts += 1;
      tryReveal();
      if (img.classList.contains("is-cover-loaded") || attempts >= maxAttempts) {
        window.clearInterval(poll);
      }
    }, 100);
  }
}

export function bindFeaturedCoverFades(root = document) {
  const scope = root?.querySelector ? root : document;
  scope
    .querySelectorAll(
      ".c-home-slideshow__cover .c-cover-media .o-image, .c-featured-project__cover .c-cover-media .o-image"
    )
    .forEach(bindCoverFade);
}

export function initFeaturedCoverMedia(root = document) {
  const scope = root?.querySelector ? root : document;
  const covers = scope.querySelectorAll?.(
    ".c-home-slideshow__cover .lazyload, .c-featured-project__cover .lazyload"
  );

  if (!covers?.length) {
    return;
  }

  covers.forEach((img) => {
    img.setAttribute("data-expand", "1000");
  });

  bindFeaturedCoverFades(scope);

  if (!window.lazySizes?.loader) {
    return;
  }

  window.lazySizes.loader.checkElems(
    scope === document ? document.getElementById("main") : scope
  );
}
